import * as Sentry from '@sentry/tanstackstart-react'

Sentry.init({
  dsn: 'https://99cc7ae77497036c903984f4e21855a2@o4511217787863040.ingest.de.sentry.io/4511890734841936',
  environment: import.meta.env.MODE,
  // 100% traces in dev to validate; 10% in prod to control quota. Tune later.
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
})
